import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";

function SvgImport() {
  return _jsxs("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("path", {
      d: "M5.279 18.998h13.094c1.17.043 3.53-.737 3.624-4.194.094-3.457-2.377-4.491-3.624-4.576C18.178 8.152 16.596 4 11.826 4s-6.197 4.322-6.197 6.228c-1.289 0-3.538 1.017-3.627 4.195-.081 2.923 2.222 4.575 3.277 4.575z",
      fill: "currentColor",
      stroke: "currentColor",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }, void 0), _jsx("path", {
      d: "M13 10.836a1 1 0 10-2 0h2zM13 20v-9.164h-2V20h2z",
      fill: "#fff"
    }, void 0), _jsx("path", {
      d: "M7.341 13.247a1 1 0 001.317 1.506l-1.316-1.506zM12 10.5l.659-.753a1 1 0 00-1.318 0L12 10.5zm3.341 4.253a1 1 0 001.318-1.506l-1.317 1.506zm-6.682 0l4-3.5-1.318-1.506-4 3.5 1.317 1.506zm2.682-3.5l4 3.5 1.318-1.506-4-3.5-1.318 1.506z",
      fill: "#fff"
    }, void 0)]
  }), void 0);
}

export default SvgImport;